import { T2CStatus } from '../constants/payments';
import { PHA_ENROLLING_T2C_SUCCESS_MSG, PHA_UNENROLLED_T2C_SUCCESS_MSG, } from '../constants/response-success-messages';
import { TPhaLocType, TProHouseAccountAction, } from '../models/b2b/payments';
import { hasCcEnrolledInT2C, shouldShowCcT2CUnenrollConfirmModal, } from './credit-cards';
export const getBadgeColor = (type) => {
    switch (type) {
        case TPhaLocType.SHOP:
            return 'info';
        case TPhaLocType.PROJECT:
            return 'medium';
        default:
            return 'primary';
    }
};
export const getT2CSuccessMessage = (action) => {
    switch (action) {
        case TProHouseAccountAction.UNENROLL:
            return PHA_UNENROLLED_T2C_SUCCESS_MSG.message;
        case TProHouseAccountAction.ENROLL:
            return PHA_ENROLLING_T2C_SUCCESS_MSG.message;
        default:
            return PHA_ENROLLING_T2C_SUCCESS_MSG.message;
    }
};
export const getBadgeVariant = (type) => {
    switch (type) {
        case TPhaLocType.SHOP:
            return 'regular';
        case TPhaLocType.PROJECT:
            return 'strong';
        default:
            return 'regular';
    }
};
export const hasProjectLOCEnrolledInT2C = (paymentCards) => {
    return paymentCards.some((loc) => loc.locType === TPhaLocType.PROJECT &&
        (loc.t2cStatus === T2CStatus.PENDING ||
            loc.t2cStatus === T2CStatus.ENROLLED));
};
export const hasShopLOCEnrolledInT2C = (paymentCards) => {
    return paymentCards.some((card) => card.locType === TPhaLocType.SHOP &&
        (card.t2cStatus === T2CStatus.PENDING ||
            card.t2cStatus === T2CStatus.ENROLLED));
};
const checkHasProjectLOC = (linesOfCredit) => {
    return linesOfCredit.some((card) => card.locType === TPhaLocType.PROJECT);
};
export const shouldShowPHAT2CUnenrollConfirmModal = ({ selectedCard, creditCards, linesOfCredit, }) => {
    const { t2cPrimary: selectedCardIsPrimaryT2C, locType } = selectedCard;
    if (locType === 'PROJECT' || !selectedCardIsPrimaryT2C) {
        return false;
    }
    const hasProjLOCEnrolledInT2C = hasProjectLOCEnrolledInT2C(linesOfCredit);
    if (!hasProjLOCEnrolledInT2C) {
        return false;
    }
    const hasCCsEnrolledInT2C = hasCcEnrolledInT2C(creditCards);
    if (hasCCsEnrolledInT2C) {
        return false;
    }
    const hasOtherShopLocEnrolledInT2C = hasShopLOCEnrolledInT2C(linesOfCredit.filter((card) => card.paymentId !== selectedCard.paymentId));
    return !hasOtherShopLocEnrolledInT2C;
};
export const shouldShowNoT2CEnrolledTenderWarning = (creditCards, linesOfCredit) => {
    const hasCCsEnrolledInT2C = hasCcEnrolledInT2C(creditCards);
    const hasT2CEnrolledLOC = hasShopLOCEnrolledInT2C(linesOfCredit);
    const hasProjectLOC = checkHasProjectLOC(linesOfCredit);
    return !hasCCsEnrolledInT2C && !hasT2CEnrolledLOC && hasProjectLOC;
};
export const showConfirmModal = (selectedCard, linesOfCredit, creditCards) => {
    if ('locType' in selectedCard && selectedCard.locType) {
        return shouldShowPHAT2CUnenrollConfirmModal({
            selectedCard,
            creditCards,
            linesOfCredit,
        });
    }
    return shouldShowCcT2CUnenrollConfirmModal({
        selectedCard,
        creditCards,
        linesOfCredit,
    });
};
